import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SearchPlusIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SearchPlusIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SearchPlusIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SearchPlusIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="SearchPlusIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M10.5 3a7.5 7.5 0 0 1 5.927 12.097q.098.044.186.113l.094.083 4 4a1 1 0 0 1-1.32 1.497l-.094-.083-4-4a1 1 0 0 1-.197-.28A7.5 7.5 0 1 1 10.5 3m0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M7.592 9.973h2.38V7.591a.595.595 0 0 1 1.191 0v2.38h2.381a.595.595 0 1 1 0 1.191h-2.38v2.381a.595.595 0 1 1-1.191 0l-.001-2.38h-2.38a.595.595 0 1 1 0-1.191"
        clipRule="evenodd"
      />
    </svg>
  )
);
SearchPlusIcon.displayName = "SearchPlusIcon";
export default SearchPlusIcon;
